// Helper for page controllers that live around a settings shell (partials/components/_settings_shell.html).
// After a section was saved or reset, call markClean(this.element, "section-key") — the shell hides that
// section's save bar and the dot on its nav item. `root` is the page element that contains the shell (or the shell itself).
export const MARK_CLEAN_EVENT = "settings-shell:mark-clean";
export const MARK_DIRTY_EVENT = "settings-shell:mark-dirty";

function shellOf(root) {
  const selector = '[data-controller~="settings-shell"]';
  return root.matches?.(selector) ? root : (root.closest?.(selector) ?? root.querySelector(selector));
}

// For changes that fire no input/change event (button clicks such as „move up”): flag the section dirty by hand.
export function markDirty(root, key) {
  shellOf(root)?.dispatchEvent(new CustomEvent(MARK_DIRTY_EVENT, { detail: { key } }));
}

export function markClean(root, key) {
  shellOf(root)?.dispatchEvent(new CustomEvent(MARK_CLEAN_EVENT, { detail: { key } }));
}
